import axios from 'axios'
import {
  ExchangePricesAttributes,
  ExchangePricesResponse,
  PriceFeedsResponse,
  PriceFeedsAttributes,
} from './types'
import staticConfig from 'src/config'

export const axiosClient = axios.create({
  baseURL: staticConfig.appApiUrl,
})

export const getExchangePrices = async (
  chainId: number,
  contractAddresses: string[],
  vsCurrencies = 'usd'
): Promise<ExchangePricesAttributes['prices']> => {
  const response: ExchangePricesResponse = await axiosClient.get(
    `exchange_prices`,
    {
      params: {
        chain_id: chainId,
        contract_addresses: contractAddresses.join(','),
        vs_currencies: vsCurrencies,
      },
    }
  )
  const data = response.data.data.attributes.prices
  return data
}

export const getPriceFeeds = async (
  chainId: number,
  contractAddresses: string[],
  vsCurrencies = 'usd'
): Promise<PriceFeedsAttributes['prices']> => {
  const response: PriceFeedsResponse = await axiosClient.get(
    `price-feeds-prices`,
    {
      params: {
        chain_id: chainId,
        contract_addresses: contractAddresses.join(','),
        vs_currencies: vsCurrencies,
      },
    }
  )
  const data = response.data.data.attributes.prices
  return data
}
